import {Component, input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {StatisticListComponent} from "../statistic-list/statistic-list.component";
import {BlockStyleEditorComponent} from "../../../block-style-editor/block-style-editor/block-style-editor.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {BlockStyleTableComponent} from "../../../block-style-editor/block-style-table/block-style-table.component";
import {BlockStyleListComponent} from "../../../block-style-editor/block-style-list/block-style-list.component";
import {
  BlockStyleParagraphComponent
} from "../../../block-style-editor/block-style-paragraph/block-style-paragraph.component";
import {BlockStyleHeaderComponent} from "../../../block-style-editor/block-style-header/block-style-header.component";
import {SimpleImageComponent} from "../../../block-style-editor/custom-tools/simple-image/simple-image.component";

@Component({
  selector: 'app-section-detail',
  standalone: true,
    imports: [
        StatisticListComponent,
        BlockStyleEditorComponent,
        MatProgressSpinnerModule,
        BlockStyleTableComponent,
        BlockStyleListComponent,
        BlockStyleParagraphComponent,
        BlockStyleHeaderComponent,
        SimpleImageComponent,
    ],
  templateUrl: './section-detail.component.html',
  styleUrl: './section-detail.component.css'
})
export class SectionDetailComponent implements OnInit, OnDestroy {
  sectionID = input<any>();
  selectedPeriod = input<any>();
  selectedBenchmark = input<any>();
  contentBlockInput = input<any>();
  contentBlocks!: any;
  statisticData!: any;

  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _languageService: LanguageService,
    private _translate: TranslateService) {
  }

  ngOnInit(): void {
    this.contentBlocks = this.contentBlockInput();

    if(this.sectionID().statistics.length > 0){
      console.log('sectionID', this.sectionID().statistics);
      this.statisticData = this.sectionID().statistics;
      //this.loadStatisticData();
    }
    this.setLanguageSubscription()
  }

  private setLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange
        .subscribe((event: LangChangeEvent) => {
          this.currentLanguage = event.lang;
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }

}
